module.exports = __webpack_public_path__ + "fonts/DM_Sans-800-latin-ext16.0d3827b.woff2";